import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

import { createOvermind } from 'overmind';
import { Provider as OvermindProvider } from 'overmind-react';
import store from './redux/store';
import Main from './components/base/main';
import Constants from './app.constants';
import { config } from './containers/overmind';

function App() {
  const overmind: any = createOvermind(config);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  window.__N = overmind;

  return (
    <OvermindProvider value={overmind}>
      <ReduxProvider store={store}>
        <Router>
          <DndProvider backend={HTML5Backend}>
            <Main />
          </DndProvider>
        </Router>
      </ReduxProvider>
    </OvermindProvider>
  );
}

const launchDarklyMap = {
  release: '602bd00528a3970b64518893',
  staging: '603fee6440f3e80e16e433af',
  local: '603fefa56590250eee60e78e',
};

export default withLDProvider({
  clientSideID: launchDarklyMap[Constants.ENV],
  user: {
    key: 'default',
    name: 'default',
    email: 'default',
  },
})(App);
